import React from 'react';

import './sport-rotate.scss';

import text from '../../../f/img/target/text-rotate.png'
import textMobile from '../../../f/img/target/text-rotate-mobile.png'
import center from '../../../f/img/target/center-image.png'



const DecorSportRotate = () => {

    return (
        <>
            <div className='img-wrapper'>
                <img src={text} className='rotate-img desktop-view' />
                <div className='img-wrap'>
                    <img src={center} className='center-img' />
                    <div className='link-to-all'><a href='https://www.artlebedev.ru/sport/' target='_blank'>Все проекты</a></div>
                </div>
                <img src={textMobile} className='rotate-img mobile-view' />
            </div>
        </>
    );
}

export default DecorSportRotate;
